/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import MessagingChannelSetup from 'cio/components/setup-guide/channels/messaging/setup';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import InAppCredentialsService from 'cio/services/in-app-credentials';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

export default class SetupGuideMessagingInAppComponent extends MessagingChannelSetup {
  @service inAppCredentials!: InAppCredentialsService;
  channel = MessagingChannelType.InApp;

  @tracked isIntegrationEnabled = false;
  showSuccessAlert = true;

  get inAppIntegrated() {
    return this.hasCompletedSetup || this.isIntegrationEnabled;
  }

  constructor(owner: unknown, args: any) {
    super(owner, args);
    this.loadIntegrationData.perform();
  }

  loadIntegrationData = dropTask(async () => {
    let { isIntegrationEnabled } = await this.inAppCredentials.loadCredential.perform();
    this.isIntegrationEnabled = isIntegrationEnabled;
    if (isIntegrationEnabled) {
      await this.inAppCredentials.loadGistAuthenticationToken.perform();
    }
  });

  @action
  onInAppEnabled() {
    this.isIntegrationEnabled = true;
    if (this.isShowingInSetupGuide) {
      this.markSetupComplete();
    }
  }
}
